import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom';
import axios from 'axios'

function Homepage(){
  const [isAuth, setIsAuth] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const isAuthenticated = () => {
      axios.get('https://job-portal-back123.herokuapp.com/auth/admin/verify', {
        credentials: "include",
        withCredentials: true,
        headers: {
          Authorization: localStorage.getItem("token")
        }
      }).then(res => {
        setIsAuth(true)
        setIsLoading(false)
      }).catch(err => {
        console.log(err)
        window.location = "/admin/signin"
      })
    }
    isAuthenticated()
  })
  return ( 
    <>
     {(!isLoading && !isAuth) && <Navigate to="/admin/signin" />}
      {(!isLoading && isAuth) && (
        <main className="admin__component">
          <form>
            <label className="homepage__form__element">
              <p>choose image 1</p>
              <input
                className="homepage__form__input"
                placeholder="image"
                type="file"
                name="image"
              />
            </label>

            <label className="homepage__form__element">
              <p>choose image 2</p>
              <input
                className="homepage__form__input"
                placeholder="image"
                type="file"
                name="image"
              />
            </label>

            <label className="homepage__form__element">
              <p>choose image 3</p>
              <input
                className="homepage__form__input"
                placeholder="image"
                type="file"
                name="image"
              />
            </label>
          </form>
        </main>
      )}  
    </>
  )
}

export default Homepage
//{/*onChange={handleChange}*/}
